import { render } from "./AppCustomizer.vue?vue&type=template&id=e55d78e2&scoped=true"
import script from "./AppCustomizer.vue?vue&type=script&lang=js"
export * from "./AppCustomizer.vue?vue&type=script&lang=js"

import "./AppCustomizer.vue?vue&type=style&index=0&id=e55d78e2&lang=scss"
import "./AppCustomizer.vue?vue&type=style&index=1&id=e55d78e2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e55d78e2"]])

export default __exports__